module.exports = __webpack_public_path__ + "static/media/stock-movement.074d679f.svg";